import React, { ReactElement } from 'react'
import styled from '@emotion/styled'
import { Flex, theme } from '@mindfulchefuk/design-system'
import { TRecipeClaim } from '@mindfulchefuk/features/Recipes/interfaces'
import { RecipeCardClaimLozenge } from '@mindfulchefuk/features/Recipes/components/RecipeCardWithClaims/RecipeClaimLozenge/RecipeCardClaimLozenge'

export type TRecipeCardClaims = {
  claims: TRecipeClaim[]
  productId: string
  productName: string
}

const FlexWithGap = styled(Flex)`
  gap: ${theme.space[8]};
`

const ClaimsWrapper = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
`

export const RecipeCardClaims = ({
  claims,
  productId,
  productName,
}: TRecipeCardClaims): ReactElement => {
  const claimsToDisplay = claims.slice(0, 3)

  return (
    <ClaimsWrapper>
      <FlexWithGap
        width="100%"
        height="100%"
        alignItems="flex-end"
        justifyContent="flex-start"
        flexDirection="column"
        position="relative"
        paddingTop={theme.space[12]}
      >
        {claimsToDisplay.map((claim) => (
          <RecipeCardClaimLozenge
            {...claim}
            productId={productId}
            productName={productName}
          />
        ))}
      </FlexWithGap>
    </ClaimsWrapper>
  )
}
